  $(document).ready(function(){
    $('.announcement-bar__message').slick({
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnFocus: false,
      pauseOnHover: false
    });
  });